import React from "react";
import { Button, Card, CardContent, Typography } from "@material-ui/core";
import { ClientServicingCss as Styles } from "../../components/clientServicing/css/ClientServicingCss";
import CancelIcon from "@material-ui/icons/Cancel";
import { Dialog as GenericDialog, GenericDialogProps } from "../../components/dialog";
import ServicingFeedDialogContent from "./ServicingFeedDialogContent";

export default function ServicingFeedback () {
    const classes = Styles();
    const [showDialog, setShowDialog] = React.useState(false);

    const dialogProps: GenericDialogProps = {
        "aria-labelledby": "customized-dialog-title",
        fullWidth: true,
        maxWidth: "md",
        content: (<>
              <ServicingFeedDialogContent setShowDialog={setShowDialog} /></>),
        dividers: true,
        dialogClassName:"topPositionXs",
        onClose: () => setShowDialog(false),
        open: showDialog,
        title: "Servicing Feedback",
        onBackdropClick: () => setShowDialog(false),
    };

    return (
            <>
                {
                        showDialog &&
                        <GenericDialog dialogClassName="serviceFeedPopUp" {...dialogProps} />
                }
            </>
    );
}